module.exports = __webpack_public_path__ + "static/img/female.ff52001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/female.png
// module id = gQUM
// module chunks = 1